export function hoursInputToMinutes(
  hoursInput: string | undefined,
): number | undefined {
  if (!hoursInput) return undefined;
  if (!hoursInput || !hoursInput.includes(':')) return undefined;

  const [h, m] = hoursInput.split(':');
  const hours = parseInt(h);
  const minutes = parseInt(m);

  if (isNaN(hours) || isNaN(minutes)) return undefined;

  return hours * 60 + minutes;
}
